// extracted by mini-css-extract-plugin
module.exports = {"container":"e_ef","image":"e_ff"};